import { render } from "./ShopFilterContainer.vue?vue&type=template&id=3f668d6f"
import script from "./ShopFilterContainer.vue?vue&type=script&lang=js"
export * from "./ShopFilterContainer.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__